import { BaseWebComponentElement } from '../../../../../../../../framework/BaseWebComponentElement';
import { ProductsGridController } from '../controller/ProductsGridController';

export class ProductsGridWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: ProductsGridController,
    });
  }

  set patchId(value: string) {
    this.setAttribute('patch-id', value);
  }

  get patchId(): string {
    return this.getAttribute('patch-id') ?? '';
  }

  set productsCount(value: number) {
    this.setAttribute('products-count', value.toString());
  }

  get productsCount(): number {
    const value = this.getAttribute('products-count');
    if (value) {
      return parseInt(value, 10);
    }

    // this attribute is used to limit the no of records fetched from back-end. (pagination: {page: number, limit: number})
    // If somehow a wrong (NaN) value gets here, fetch data with default = 20.
    return 20;
  }
}
